/**
 * The app's query client turns `retryOnMount` off, which would keep a failed
 * load failed on every later visit until a full page reload.
 */
export const CONTROL_LIST_QUERY_OPTIONS = { retryOnMount: true };
